import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/mocks/comics';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryShowcase() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="分类总览"
          title="按口味挑选，总有一款适合你"
          desc="从热血到日常，从悬疑到恋爱，八大分类任你逛。"
        />
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {CATEGORIES.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              onClick={scrollTop}
              className="group flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{c.desc}</p>
                <p className="mt-1 text-xs font-medium text-primary-600">{c.count} 部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}